import { Injectable, inject } from '@angular/core';
import { ReportingApiService } from './reporting-api.service';
import { ReportDataAvailability, normalizeReportDataAvailability } from '../utils/report-data-availability.utils';
export { ReportDataAvailability, availabilityForReport } from '../utils/report-data-availability.utils';

@Injectable({ providedIn: 'root' })
export class ReportDataAvailabilityService {
  private readonly api = inject(ReportingApiService);
  async resolve(): Promise<ReportDataAvailability> {
    try {
      const data = await this.api.getReportDataAvailability();
      return normalizeReportDataAvailability(data);
    } catch {
      return normalizeReportDataAvailability(null);
    }
  }
}
